interface ShowCodeButtonProps {
  onClick: () => void
}

export default function ShowCodeButton({ onClick }: ShowCodeButtonProps) {
  return (
    <button
      onClick={onClick}
      className="fixed right-0 top-1/2 -translate-y-1/2 z-[100] bg-matcha dark:bg-shamrock text-licorice dark:text-white px-5 py-4 rounded-l-lg shadow-lg hover:bg-lime dark:hover:bg-cactus transition-colors duration-200 flex items-center gap-2 text-base font-medium hidden md:flex"
      style={{ writingMode: 'vertical-rl' }}
      aria-label="Show widget initialization code"
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-5 rotate-90">
        <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5" />
      </svg>
      <span>Get Code</span>
    </button>
  )
}
